import React, { useMemo } from "react";
import "./sideMenu.css";
import SideMenuBtn from "./sideMenuBtn";
import dashboard from "../../images/dashboard.svg";
import student from "../../images/students-dashboard.svg";
import teacher from "../../images/teacher-dashboard-com.svg";
import parents from "../../images/parents-dashboard.svg";
import academic from "../../images/academic-icon.svg";
import bus from "../../images/bus-icon.svg";
import menu from "../../images/menu.svg";
import money from "../../images/money-icon.svg";
import notification from "../../images/notification-icon.svg";
import SideMenuHeader from "./sideMenuHeader";
import { Colors } from "../../Constants/colors";
import { Paths } from "../../Constants/paths";
import { SchoolPricesNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { FLEX_DIRECTION } from "../../Constants/Enums/styles.enum";

interface SubButton {
  name: string;
  navigateTo?: string;
  onClick?: () => void;
}

interface MenuItem {
  title: string;
  icon: {
    src: string;
    alt: string;
  };
  navigateTo?: string;
  subButtons?: SubButton[];
}

const SideMenu: React.FC = () => {
  const menuItems: MenuItem[] = useMemo(
    () => [
      {
        title: "Dashboard",
        icon: {
          src: dashboard,
          alt: "Dashboard",
        },
        navigateTo: Paths.Dashboard,
      },
      {
        title: "Student",
        icon: {
          src: student,
          alt: "Students",
        },
        subButtons: [
          {
            name: "All students",
            navigateTo: Paths.StudentList,
          },
          {
            name: "Admission Form",
            navigateTo: Paths.StudentAdmission,
          },
        ],
      },
      {
        title: "Teacher",
        icon: {
          src: teacher,
          alt: "Teachers",
        },
        subButtons: [
          {
            name: "All teachers",
            navigateTo: Paths.TeachersList,
          },
          {
            name: "Register teacher",
            navigateTo: Paths.RegisterTeachers,
          },
        ],
      },
      {
        title: "Parents",
        icon: {
          src: parents,
          alt: "Parents",
        },
        subButtons: [
          {
            name: "All Parents",
            navigateTo: Paths.ParentsList,
          },
          {
            name: "Register Parent",
            navigateTo: Paths.RegisterParent,
          },
        ],
      },
      {
        title: "Subject",
        icon: {
          src: academic,
          alt: "Subjects",
        },
        navigateTo: Paths.Subject,
      },
      {
        title: "Classes",
        icon: {
          src: academic,
          alt: "Classes",
        },
        navigateTo: Paths.Class,
      },
      {
        title: "Results",
        icon: {
          src: academic,
          alt: "Results",
        },
        subButtons: [
          {
            name: "Add result",
            navigateTo: Paths.AddResult,
          },
        ],
      },
      {
        title: "Branches",
        icon: {
          src: menu,
          alt: "Branches",
        },
        navigateTo: Paths.Branch,
      },
      {
        title: "Blocks",
        icon: {
          src: menu,
          alt: "Blocks",
        },
        navigateTo: Paths.Block,
      },
      {
        title: "Transport",
        icon: {
          src: bus,
          alt: "Transport",
        },
        navigateTo: Paths.Transport,
      },
      {
        title: "Notification",
        icon: {
          src: notification,
          alt: "Notifications",
        },
        navigateTo: Paths.Notification,
      },
      {
        title: "School prices",
        icon: {
          src: money,
          alt: "School Pricing",
        },
        navigateTo: `${Paths.SchoolPrices}?section=${SchoolPricesNavigationHeader.ACADEMIC_PRICE}`,
      },
    ],
    [],
  );

  return (
    <nav
      className="side-menu-scrollbar"
      style={{
        display: "flex",
        flexDirection: FLEX_DIRECTION.COLUMN,
        height: "100%",
        width: "100%",
        backgroundColor: Colors.BurgundyRed,
        overflowY: "hidden",
        overflowX: "hidden",
        boxShadow: "2px 0 8px rgba(0, 0, 0, 0.1)",
      }}
      role="navigation"
      aria-label="Main navigation"
    >
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: Colors.BurgundyRed,
        }}
      >
        <SideMenuHeader />
      </div>
      <div
        className="side-menu-scrollbar"
        style={{
          display: "flex",
          flexDirection: FLEX_DIRECTION.COLUMN,
          flex: 1,
          gap: "2px",
          paddingTop: "8px",
          paddingBottom: "8px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {menuItems.map((item) => (
          <SideMenuBtn
            key={item.title}
            title={item.title}
            icon={item.icon}
            navigateTo={item.navigateTo}
            subButtons={item.subButtons}
          />
        ))}
      </div>
    </nav>
  );
};

export default SideMenu;
